<template>
  <div class="tw-flex tw-flex-wrap">
    <template v-for="(badge, index) in badgesList">
      <div class="tw-mr-2 tw-mb-2 tw-cursor-pointer tw-relative" @click="showGoalBadgeDetails(badge)" :key="index">
        <div
          class="tw-absolute tw-top-0 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-3 tw-z-20 tw-text-center tw-bg-app-primary-orange tw-text-app-primary-orange-contrast tw-rounded-full tw-px-2 tw-p-1 tw-text-xs"
          v-if="groupBadges && badge.badgesCount > 1">
          {{ badge.badgesCount }}
        </div>
        <UserPhoto :photo="badge.url" :photo-size="[
          'tw-rounded-full tw-z-10',
          { 'tw-w-12 tw-h-12': listSize === 'normal' },
          { 'tw-w-8 tw-h-8': listSize === 'tiny' },
          { 'tw-w-24 tw-h-24': listSize === 'large' },
        ]" class="tw-mb-1" :title="badge.title" />
        <p class="tw-font-bold tw-text-sm" v-if="listSize === 'large'" style="max-width: 96px;">
          {{ badge.title }}
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import _groupBy from 'lodash/groupBy';

export default {
  name: 'UserGoalsBadges',
  props: {
    tiny: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    groupBadges: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      badges: [],
    };
  },
  computed: {
    listSize() {
      if (this.tiny) {
        return 'tiny';
      }

      if (this.large) {
        return 'large';
      }

      return 'normal';
    },
    badgesList() {
      if (!this.groupBadges) {
        return this.badges;
      }

      const groupedBadges = _groupBy(this.badges, 'goalid');

      return Object.keys(groupedBadges).map((goalid) => {
        const goalBadge = groupedBadges[goalid][0];

        return {
          goalid,
          badgesCount: groupedBadges[goalid].length,
          ...goalBadge,
        };
      });
    },
  },
  methods: {
    async showGoalBadgeDetails(goalBadge) {
      await this.$nextTick();

      this.$store.commit('openRightSideNav', 'Goal Badge Details');
      await this.$nextTick();

      this.$store.commit('showGoalBadgeDetails', goalBadge);
    },
  },
  async created() {
    this.loading = true;
    await this.$nextTick();

    this.badges = await this.$store.dispatch('getUserGoalsBadges', this.$store.getters.userId);

    this.loading = false;
  },
};
</script>

<style></style>
